import { render, staticRenderFns } from "./CalendarsSettings.vue?vue&type=template&id=5abcff2d&"
import script from "./CalendarsSettings.vue?vue&type=script&lang=js&"
export * from "./CalendarsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports